var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "24",
        height: "24"
      }
    },
    [
      _c("rect", {
        attrs: { width: "24", height: "24", fill: "rgba(227, 227, 227, 0.01)" }
      }),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          attrs: {
            d:
              "M12.68,8.12h-4.67c-.25,0-.46.20-.46.46v2.77c0,.25.20.46.46.46h4.67c.25,0,.46-.20.46-.46v-2.77c0-.25-.20-.46-.46-.46ZM12.22,10.90h-3.76v-1.86h3.76v1.86Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M17.67,15.11c-.43,0-.77-.35-.77-.77v-4.10c.83-.16,1.46-.89,1.46-1.77,0-.82-.56-1.51-1.31-1.72l1.40-1.40c.20-.20.20-.51,0-.71-.20-.20-.51-.20-.71,0l-1.70,1.70c-.09.09-.15.22-.15.35v7.64c0,.98.79,1.77,1.77,1.77.29,0,.53.24.53.53s-.24.53-.53.53h-2.75V7.55c0-.83-.68-1.51-1.51-1.51h-6.14c-.83,0-1.51.68-1.51,1.51v10.95h-.47c-.28,0-.50.22-.50.50s.22.50.50.50h10.08c.28,0,.50-.22.50-.50s-.22-.50-.50-.50h-.47v-.32h2.75c.85,0,1.53-.69,1.53-1.53s-.69-1.53-1.53-1.53ZM16.90,7.75c.27.13.46.40.46.72,0,.32-.19.59-.46.72v-1.45ZM13.92,18.50h-7.15V7.55c0-.28.23-.51.51-.51h6.14c.28,0,.51.23.51.51v10.95Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M11.76,15.31c-.04-.10-.08-.18-.13-.26l-.79-1.55c-.09-.17-.26-.27-.45-.27s-.36.11-.45.27l-.79,1.55c-.05.08-.09.16-.12.23-.02.04-.04.09-.04.13-.04.13-.06.26-.06.39,0,.78.66,1.42,1.46,1.42s1.46-.64,1.46-1.42c0-.15-.03-.30-.08-.46-.00-.01-.01-.03-.01-.04ZM10.40,16.23c-.25,0-.46-.19-.46-.42,0-.04.01-.08.03-.13.00-.01.00-.01.00-.02.01-.03.02-.05.03-.07.01-.02.02-.03.03-.05l.36-.70.36.70c.01.02.02.04.03.05.01.01.02.03.03.05.00.01.01.02.01.03.00.01.01.02.01.03,0,.19-.21.42-.46.42Z"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }